import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsLockup } from 'components/common/ns-lockup/NsLockup';
import { useCrossSellData } from '../hooks/useCrossSellData';

export const testId = 'crossSellOfferTestId';

export const CrossSellOffer = () => {
  const { showOfferDetail, offerDetail, handleGoNext } = useCrossSellData();
  const messageKey = 'message-information';

  if (!showOfferDetail) {
    return null;
  }

  return (
    <NsPanel decoration="orange" data-testid={testId}>
      <NsLockup
        type="lockbox"
        heading={offerDetail?.[messageKey].title}
        image="https://www.britishgas.co.uk/aem6/content/dam/britishgas/images/hive-exclusive-lockup.jpg"
        action={<NsPrimaryCta onClick={handleGoNext}>Shop Hive</NsPrimaryCta>}
      >
        <div
          slot="paragraph"
          dangerouslySetInnerHTML={{
            __html: offerDetail?.[messageKey]?.message
          }}
        ></div>
      </NsLockup>
    </NsPanel>
  );
};
